import { ArrowUpRight, Ban, Clock3, MapPin, Radio, ShieldCheck, Smartphone, Square, Undo2, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { formatDate } from "@/api/client";
import { StatusPill } from "@/components/StatusPill";

export const MapDetailsPanel = ({ point, canAct, onAction }) => {
  if (!point) {
    return (
      <aside className="map-details empty" data-testid="map-empty-details-panel">
        <MapPin size={29} />
        <h2>Select a map marker</h2>
        <p>Inspect live activity, creator locations, and recently online users.</p>
        <div className="map-legend" data-testid="map-legend">
          <span><i className="live" />Live now</span><span><i className="creator" />Creator</span><span><i className="user" />User</span>
        </div>
      </aside>
    );
  }

  return (
    <aside className="map-details" data-testid="map-selected-details-panel">
      <div className="map-details-heading">
        <span className={`map-person-icon ${point.category}`}><UserRound size={19} /></span>
        <div><span className="overline">{point.category === "live" ? "Live now" : point.category}</span><h2 data-testid="map-selected-user-name">{point.name}</h2></div>
      </div>
      <div className="map-detail-statuses">
        <StatusPill value={point.banned ? "banned" : "active"} testId="map-selected-user-status" />
        {point.live && <StatusPill value="live" testId="map-selected-live-status" />}
      </div>
      <dl className="map-detail-list">
        <div><dt><MapPin size={14} />Location</dt><dd data-testid="map-selected-location">{[point.city, point.country].filter(Boolean).join(", ") || `${point.position.lat.toFixed(5)}, ${point.position.lng.toFixed(5)}`}</dd></div>
        {point.username && <div><dt><UserRound size={14} />Username</dt><dd data-testid="map-selected-username">@{point.username}</dd></div>}
        <div><dt><Smartphone size={14} />Platform</dt><dd data-testid="map-selected-platform">{point.platform ? point.platform.toUpperCase() : "Unknown"}</dd></div>
        <div><dt><Clock3 size={14} />Last activity</dt><dd data-testid="map-selected-last-activity">{formatDate(point.lastOnline)}</dd></div>
        {point.live && <div><dt><Radio size={14} />Broadcast</dt><dd data-testid="map-selected-live-title">{point.live.title || point.live.name || "Active session"}</dd></div>}
      </dl>
      {point.email && <p className="map-user-email" data-testid="map-selected-user-email">{point.email}</p>}
      {point.userId && <Link className="button secondary full map-profile-link" to={`/users?q=${encodeURIComponent(point.userId)}`} data-testid="map-view-user-profile-link"><UserRound size={16} />View profile<ArrowUpRight size={15} /></Link>}
      {canAct ? (
        <div className="map-action-zone" data-testid="map-super-admin-actions">
          <span><ShieldCheck size={14} />Super admin controls</span>
          <div>
            {point.userId && (point.banned ?
              <button className="button secondary" onClick={() => onAction("unban", point)} data-testid="map-unban-user-button"><Undo2 size={15} />Unban</button> :
              <button className="button danger" onClick={() => onAction("ban", point)} data-testid="map-ban-user-button"><Ban size={15} />Ban user</button>)}
            {point.liveId && <button className="button danger" onClick={() => onAction("force-end", point)} data-testid="map-force-end-button"><Square size={14} />End live</button>}
          </div>
        </div>
      ) : <p className="inspection-only" data-testid="map-inspection-only-message">Inspection access only. Actions require super admin.</p>}
    </aside>
  );
};